export function toCamelCase(str) {
  const words = str?.split(' ')
  const camelCaseWords = words?.map(word => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
  })
  return camelCaseWords?.join(' ')
}
